import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators, FormArray, FormControl, NgForm} from '@angular/forms';
import {EntidadeService} from 'src/app/service/entidade/entidade.service';
import {MatDialog} from '@angular/material/dialog';
import {MatFormFieldControl} from '@angular/material/form-field';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {ToasterService, ToasterConfig} from 'angular2-toaster';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {THIS_EXPR} from '@angular/compiler/src/output/output_ast';
import {Title} from '@angular/platform-browser';


@Component({
    selector: 'app-lista-unificada-precatorios',
    templateUrl: './lista-unificada-precatorios.component.html',
    styleUrls: ['./lista-unificada-precatorios.component.css'],
    providers: [EntidadeService, MatDialog, {provide: MatFormFieldControl, useExisting: FormBuilder}]
})
export class ListaUnificadaPrecatoriosComponent implements OnInit {

    pesquisarForm: FormGroup;
    progressBar: any = 0;
    valorInput: any;
    //entidades: Observable<EntidadeDevedora[]>;
    entidades: any[] = [];
    enteDevedores: Array<any> = new Array();
    entidadesDevedoras: Array<any> = new Array();
    retornaPesquisa: boolean = false;
    mostrarTodos: boolean = false;
    totalElements: number = 0;
    precatoriosPrioridade: any = {};
    token: string | undefined;
    pageNumber:number;
    pageSize:number;
    radioValue:string;
 


    @BlockUI('conteudo-captcha') blockUIList: NgBlockUI;
    @BlockUI() blockUI: NgBlockUI;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    private captchaResolvida: boolean;


    constructor(private formBuilder: FormBuilder,
                private entidadeService: EntidadeService,
                private dialog: MatDialog,
                private toast: ToasterService,
                private titleService: Title) {
        this.token = undefined;
        this.captchaResolvida = false;
    }

// Campos do Grid

    displayedColumns: string[] = ['ordemCronologica', 'siglaTipo', 'cdNatureza', 'nuAnoOrcamento', 'cdPrecatorio', 'dataExp', 'hora', 'valor'];


  ngOnInit(): void {
    this.pesquisarForm = this.formBuilder.group({
      enteDevedor: [0, Validators.required],
      entidadeDevedora:[0],
      numeroPrecatorio:[''],
      natureza:['TODOS']
         
    });
    this.radioValue = 'TODOS';
    this.titleService.setTitle("Lista de Unificada de Precatórios");
    this.pageNumber = 0;
    this.pageSize = 20;
    this.blockUIList.start();
    
    //this.entidades.paginator = this.paginator;  
  }
  
    public validarCaptcha(form: NgForm): void {
        if (form.invalid) {
            for (const control of Object.keys(form.controls)) {
                form.controls[control].markAsTouched();
            }
            return;
        }
        this.captchaResolvida = true;
        this.listaEnteDevedor();
        this.blockUIList.stop();
    }


    get f() {
        return this.pesquisarForm.controls;
    }

//Carrega os dados do combo Natureza
    naturezas: any = [
        {id: 'TODOS', valor: 'TODOS'},
        {id: 'A', valor: 'ALIMENTAR'},
        {id: 'C', valor: 'COMUM'}
    ];

    grupoDados: any = [
        {id: 'TODOS', valor: 'TODOS'},
        {id: 'CRONOLOGICA', valor: 'Ordem Cronológica'},
        {id: 'PRIORIDADE', valor: 'Superpreferência (Prioridade)'}
    ];

    // Carrega os dados do combo Ente Devedor
    listaEnteDevedor() {

        this.entidadeService.listEnteDevedor().subscribe(data => {
            this.enteDevedores = data;
        }, error => {
            console.log(error);
        });
    }

    //Carrega os dados do combo Entidade Devedora
    listaEntidadeDevedora() {
        this.entidadeService.listEntidadeDevedora(this.pesquisarForm.get('enteDevedor').value).subscribe(data => {
            this.entidadesDevedoras = data;
        }, error => {
            console.log(error);
        });
    }

    //Carrega os dados do grid ao clicar no botão
    pesquisar(mostrarTodos:boolean) {
        
        this.pageNumber = 0;
        this.pageSize = 20;
        
        if (!this.captchaResolvida) {
            this.toast.pop('warning', 'Resolva a captcha', 'É necessário resolver a captcha para pesquisar!');
            return;
        }
        if (this.pesquisarForm.get('enteDevedor').value == 0 &&
            this.pesquisarForm.get('entidadeDevedora').value == 0 &&
            this.pesquisarForm.get('numeroPrecatorio').value == '' &&
            this.pesquisarForm.get('natureza').value == 'TODOS') {

            this.toast.pop('warning', 'Necessário selecionar um filtro', ' Selecione um dos filtros por favor.');
            return;
        }

        if (this.radioValue == undefined) {
            this.toast.pop('warning', 'Necessário selecionar um agrupamento de dados', 'Marque uma das caixas de seleção');
            return;
        }

        this.listarPrecatorios(mostrarTodos);
    }

    isGroup(index, item): boolean {
        return item.groupHeader;
    }

    private listarPrecatorios(mostrarTodos: boolean) {
        this.blockUI.start();
        // this.retornaPesquisa = true;
        this.entidades = [];
        const addEntidade = (entidade: any) => {
            var listaPrecatorio = entidade.listaPrecatorio;

            const groupBy = <T, K extends keyof any>(list: T[], getKey: (item: T) => K) =>
                list.reduce((previous, currentItem) => {
                    const group = getKey(currentItem);
                    if (!previous[group]) previous[group] = [];
                    previous[group].push(currentItem);
                    return previous;
                }, {} as Record<K, T[]>);

            var precatoriosAgrupados = groupBy(listaPrecatorio, i => i["flprioridade"]);

            entidade.listaPrecatorio = [];
            if (precatoriosAgrupados["1"] && precatoriosAgrupados["1"].length > 0) {
                entidade.listaPrecatorio.push({groupHeader: "Preferências"});
                entidade.listaPrecatorio = entidade.listaPrecatorio.concat(precatoriosAgrupados["1"]);
            }
            if (precatoriosAgrupados["0"] && precatoriosAgrupados["0"].length > 0) {
                entidade.listaPrecatorio.push({groupHeader: "Ordem Cronológica Geral"});
                entidade.listaPrecatorio = entidade.listaPrecatorio.concat(precatoriosAgrupados["0"]);
            }
            this.entidades.push(entidade);

        };
    
    if(mostrarTodos){
      this.entidadeService.buscarTodosPorFiltro(this.getFiltro(mostrarTodos)).subscribe(data => {
        data.forEach(element => {
          addEntidade(element);
         });  
        this.blockUI.stop();
        this.retornaPesquisa = true; 
        if(this.totalElements < 1){
          this.toast.pop('warning', 'Nenhum resultado encontrado.', ' Por favor tente novamente.')
          this.retornaPesquisa = false;
        }      
       }, error => {
        this.blockUI.stop();
        this.toast.pop('warning', 'Nenhum resultado encontrado.', ' Por favor tente novamente.')
        this.retornaPesquisa = false; 
          
      });
    }else{
      this.entidadeService.buscarListaPorFiltro(this.getFiltro(mostrarTodos)).subscribe(data => {
       data.content.forEach(element => {
        addEntidade(element);
       });        
        if(this.pageNumber == 0){
          this.totalElements = data.totalElements;
          this.retornaPesquisa = true;
        }
        if(this.entidades.length < 1){
          this.toast.pop('warning', 'Nenhum resultado encontrado.', ' Por favor tente novamente.')
          this.retornaPesquisa = false;
        }
        this.blockUI.stop(); 
       }, error => {
        this.blockUI.stop();
        this.toast.pop('warning', 'Nenhum resultado encontrado.', ' Por favor tente novamente.')
        this.retornaPesquisa = false;
  
      });
    }
}

    nextPage(e: PageEvent) {
        this.pageNumber = e.pageIndex;
        this.pageSize = e.pageSize;
        this.listarPrecatorios(false);
    }

    imprimir() {
        this.blockUI.start();

        this.entidadeService.obterRelatorio(this.getFiltro(true)).subscribe(data => {
            this.blockUI.stop();
            this.downloadFile(data);
        }, error => {
            console.log(error);
            this.blockUI.stop();
        });


    }

    downloadFile(data: any) {
            const blob = new Blob([data], {type: 'application/pdf'});
        const url = window.URL.createObjectURL(blob);
        window.open(url);
    }

    private getFiltro(mostrarTodos: boolean): any {
        const filtro: any = {};

        filtro.cdunidade = this.pesquisarForm.get('enteDevedor').value;
        filtro.numPrecatorio = this.pesquisarForm.get('numeroPrecatorio').value;
        filtro.cRequerida = this.pesquisarForm.get('entidadeDevedora').value;
        filtro.natureza = this.pesquisarForm.get('natureza').value;
        filtro.mostrarTodos = mostrarTodos;
        filtro.page = this.pageNumber+1;
        filtro.size = this.pageSize;
        filtro.grupoDados = this.radioValue;
        
        return filtro;
    }

    public config: ToasterConfig =
        new ToasterConfig({
            showCloseButton: false,
            tapToDismiss: false,
            timeout: 9000
        });
    blockTemplate: any;


}
